import { CalendarView } from '../type';

const isSameDay = (date1: Date | null, date2: Date | null, view: CalendarView = 'day'): boolean => {
  if (date1 === null || date2 === null) return false;

  switch (view) {
    case 'day':
      return date1.getFullYear() === date2.getFullYear()
        && date1.getMonth() === date2.getMonth()
        && date1.getDate() === date2.getDate();
    case 'month':
      return date1.getFullYear() === date2.getFullYear()
        && date1.getMonth() === date2.getMonth();
    case 'year':
      return date1.getFullYear() === date2.getFullYear();
    default:
      return false;
  }
};

export default isSameDay;
